module.exports = __webpack_public_path__ + "img/free.3bc0f813.svg";